export default __webpack_public_path__ + "static/media/25t.fe3fb47c.jpg";